import { Outlet, createFileRoute, useMatch } from "@tanstack/react-router";
import { z } from "zod";
import { DocumentsPage } from "./index";

export const documentsSearchSchema = z.object({
  doc: z.string().optional(),
  showUpload: z.boolean().optional(),
});

function DocumentsLayout() {
  const isChildRoute = useMatch({
    from: "/$workspaceSlug/documents/$documentId",
    shouldThrow: false,
  });

  return (
    <>
      <DocumentsPage />
      {isChildRoute && <Outlet />}
    </>
  );
}

export const Route = createFileRoute("/$workspaceSlug/documents")({
  component: DocumentsLayout,
  validateSearch: documentsSearchSchema,
});
